import type { StreamsFilters } from '../types';

export const streamKeys = {
  all: ['streams'] as const,
  lists: () => [...streamKeys.all, 'list'] as const,
  list: (filters: StreamsFilters) => [...streamKeys.lists(), filters] as const,
  editData: () => [...streamKeys.all, 'edit'] as const,
  edit: (id: string) => [...streamKeys.editData(), id] as const,
  newOptions: () => [...streamKeys.all, 'new-options'] as const,
  organisations: () => [...streamKeys.all, 'organisations'] as const,
};
